import { useEffect } from 'react';

const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined;

export function useBackButton(onBack: () => void, visible: boolean = true) {
  useEffect(() => {
    if (!tg?.BackButton) return;

    if (visible) {
      tg.BackButton.show();
      tg.BackButton.onClick(onBack);
    } else {
      tg.BackButton.hide();
    }

    return () => {
      tg.BackButton.offClick(onBack);
      tg.BackButton.hide();
    };
  }, [onBack, visible]);
}
